import { isMobile } from '@pascal/pascal-core';
import { containerNames } from '../../enums/containerNames';
import { PixiBase } from '../../core/pixi/PixiBase';
import { gameResourceNames } from '../../core/pixi/resources';
import { Spine } from '../../services/spine';
import { CHARACTER_ANIMATION_NAMES } from '../../core/constants/gameLayers';
import { mobileGameConfigs } from '../../core/pixi/config';

export class CharacterDrawer {
  constructor() {
    this.animations = {};
    this.characterContainer = PixiBase.createContainer(containerNames.characterContainer);
  }

  setupCharacter() {
    this.character = new Spine({ key: gameResourceNames.character });
    if (isMobile()) {
      const { width, height } = mobileGameConfigs;
      PixiBase.setPosition(this.character, { x: width / 2, y: height / 2 });
    } else {
      PixiBase.setPosition(this.character, { x: 276, y: 333 });
    }
    this.character.play(CHARACTER_ANIMATION_NAMES.Idle, true);
    this.characterContainer.addChild(this.character);
  }

  playCharacterStaticAnimation() {
    return this.character.play(CHARACTER_ANIMATION_NAMES.Idle, true);
  }

  playSharkAnimation() {
    return this.character.play(CHARACTER_ANIMATION_NAMES.Shark, false);
  }

  playCharacterFishingAnimation() {
    return this.character.play(CHARACTER_ANIMATION_NAMES.Fishing, false);
  }

  execute(config) {
    this.config = config;
    this.setupCharacter();
  }
}
